/**
 * LocaleToggle — low-tier component.
 *
 * Compact PL|EN toggle for navigation/header.
 * Strictly props-driven: no store or API access.
 * Parent provides currentLocale and onToggle callback.
 */

import type { Locale } from '@/types/auth'

interface LocaleToggleProps {
    currentLocale: Locale
    onToggle: (locale: Locale) => void
    variant?: 'compact' | 'full'
}

export function LocaleToggle({ currentLocale, onToggle, variant = 'compact' }: LocaleToggleProps) {
    const isCompact = variant === 'compact'

    return (
        <div className={`flex rounded-md border border-border overflow-hidden ${isCompact ? 'text-xs' : 'text-sm'}`}>
            <button
                onClick={() => onToggle('pl')}
                className={`${isCompact ? 'px-2 py-1' : 'px-3 py-2'} font-medium transition-colors ${
                    currentLocale === 'pl'
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-card text-muted-foreground hover:bg-accent hover:text-foreground'
                }`}
            >
                PL
            </button>
            <button
                onClick={() => onToggle('en')}
                className={`${isCompact ? 'px-2 py-1' : 'px-3 py-2'} font-medium transition-colors border-l border-border ${
                    currentLocale === 'en'
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-card text-muted-foreground hover:bg-accent hover:text-foreground'
                }`}
            >
                EN
            </button>
        </div>
    )
}
